import {blue600, grey400, white} from 'material-ui/styles/colors';

import {typography} from 'material-ui/styles';
const styles = {
    toggleDiv: {
        maxWidth: 300,
        marginTop: 40,
        marginBottom: 5
    },
    toggleLabel: {
        color: grey400,
        fontWeight: 100
    },
    buttons: {
        float: 'right'
    },
    saveButton: {
        marginLeft: 5
    },
    usersHeader: {
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue600,
        color: white
    },
    editBox: {
        marginBottom: 30,
        paddingBottom: 30
    },
    avatar: {
        position: 'relative',
        top: -20,
        borderRadius: '10%',
        boxShadow: 'rgba(0, 0, 0, 0.22) 0px 1px 6px, rgba(0, 0, 0, 0.22) 0px 1px 4px'
    },
    box: {
        marginTop: 40,
        paddingRight: 20,
        paddingBottom: 20,
        paddingLeft: 20
    }
};

export default styles;



// WEBPACK FOOTER //
// src/containers/application/ApplicationPage/ApplicationPage.css.js